import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import Formsy from 'formsy-react';
import { Trash, User, XIcon } from 'lucide-react';
import Moment from 'moment-timezone';
import { DefaultSheet, DefaultTooltip, Row, Col, Button, Label, FormGroup, DefaultPopover, Separator, CardActions, Card, CardContent, CardHeader, Switch, DefaultTable, ButtonIcon, DropdownMenuItem, DropdownMenu, DropdownMenuTrigger, DropdownMenuContent } from 'twyne-new.ui';

import InputSearchList from '@/components/InputSearchList';
import { useGlobalStore } from '@Stores/global';
import Input from 'components/form/Input';
import { booleanOptions } from 'components/rules/options';
import userProfileSearchStore from 'modules/path/stores/user_profile_search';

import Form from './Form';
import profileFields from './fields'

const propTypes = {
  toggle: PropTypes.func,
};

export default class ProfileTool extends React.Component {
  state = {
    savedSearches: [],
    values: {},
    showInactives: false,
    searchRun: false,
    open: false,
    fields: null,
  }

  componentWillMount() {
    this.loadSavedSearches()
  }

  toggleModal = () => {
    this.setState({ open: !this.state.open })
  }

  loadSavedSearches = async () => {
    const savedSearchesResponse = await userProfileSearchStore.all()
    this.setState({ savedSearches: savedSearchesResponse.data })
  }

  handleSaveSearch = async description => {
    const payload = { description, search: this.state.values }
    await userProfileSearchStore.save(payload)
    this.loadSavedSearches()
  }

  handleLoad = savedSearch => {
    this.setState({ values: null }, () => {
      const { search: values } = savedSearch
      this.state.groups.map(group => values[group] = values[group] || {})
      if (values.context.dateOfRequest) {
        values.context.dateOfRequest = Moment(values.context.dateOfRequest)
      }
      if (values.consumerData.dob) {
        values.consumerData.dob = Moment(values.consumerData.dob)
      }
      this.setState({ values })
    })
  }

  handleDelete = savedSearch => {
    userProfileSearchStore.delete(savedSearch)
    this.loadSavedSearches()
  }

  handleCustomFields = customFields => {
    const renameCustomFields = {}
    Object.entries(customFields).map(entry => {
      const [key, value] = entry
      renameCustomFields[key.substring(3)] = value
    })
    return renameCustomFields
  }

  handleRunSearch = async () => {
    const { customFields, ...payload } = this.state.values
    if (customFields) {
      payload.customFields = this.handleCustomFields(customFields)
    }
    const profilesFound = await userProfileSearchStore.testProfile(payload, this.state.showInactives);
    this.setState({ profilesFound, searchRun: true })
  }

  hangleChangeForm = values => {
    this.setState({ values })
  }

  ShowInactivesSwicth = () => {
    const { showInactives } = this.state

    return <>
      <Label>Show inactives</Label>
      <Switch value={showInactives} onChange={() => this.setState({ showInactives: !showInactives })} />
    </>
  }

  ResultTable = () => {
    const { profilesFound, searchRun } = this.state

    if (!searchRun) {
      return null
    }

    const columns = [{
      dataField: '',
      text: 'Priority',
      formatter: (_, __, index) => <div>{++index}</div>,
    }, {
      dataField: 'pathUserProfile',
      text: 'Profile',
      formatter: col => col?.id && <Link to={`/path/dashboard/user_profile/${col?.id}`}>
        {`${col?.id} - ${col?.name}`}
      </Link> || col?.name,
    }]

    this.state.showInactives && columns.push({
      dataField: 'active',
      text: 'Active',
      formatter: col => <div>{col ? 'True' : 'False'}</div>,
    })

    return <Card className='m-4 mt-0!'>
      <CardHeader>
        <CardHeader className='text-lg'>
          Search Results
        </CardHeader>
        <CardActions>
          <this.ShowInactivesSwicth />
        </CardActions>
      </CardHeader>
      <CardContent>
        <DefaultTable
          data={profilesFound}
          columns={columns}
          noDataIndication={() => 'No content to show.'}
          className='mb-[80px]' />
      </CardContent>
    </Card>
  }

  LoadSearchPopOver = ({ data, onLoadSearch, onDelete, children }) => {
    const [open, setOpen] = useState(false)
    const [search, setSearch] = useState('')
    const normalizedSearch = search.trim().toLowerCase()
    const filteredSearches = data.filter(savedSearch => {
      if (!normalizedSearch) {
        return true
      }

      return (savedSearch.description || '').toLowerCase().includes(normalizedSearch)
    })

    const handleLoadSearch = search => () => {
      onLoadSearch(search)
      setOpen(false)
    }

    const handleDeleteSearch = search => evt => {
      onDelete(search)
      evt.stopPropagation()
    }

    const ListSearch = () => {
      if (!data.length) {
        return 'No saved searches'
      }

      if (!filteredSearches.length) {
        return <div className='twy-text-base-accent text-center '>No saved searches found</div>
      }

      return <>
        {filteredSearches.map(search => <>
          <DropdownMenuItem key={search.id} className='group relatove' onClick={handleLoadSearch(search)} >
            <span className='twy-text-base-accent'>{search.description}</span>
            <ButtonIcon content='Delete' className='absolute right-2 top-1/2 -translate-y-1/2'>
              <Trash size={14} onClick={handleDeleteSearch(search)} />
            </ButtonIcon>
          </DropdownMenuItem>
        </>)}
      </>
    }

    const handleClose = () => {
      setOpen(false)
      setSearch('')
    }

    return <>
      <DropdownMenu onOpenChange={nextOpen => !nextOpen ? handleClose() : setOpen(true)} open={open}>
        <DropdownMenuTrigger asChild>
          <Button variant='outline' color='accent'>{children}</Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className='overflow-y-auto w-74 max-h-100' side='right'>
          <InputSearchList
            className='mb-2'
            placeholder="Search saved searches"
            value={search}
            onChange={setSearch}
          />
          <ListSearch />
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  }

  SaveSearchPopOver = ({ onSave, children }) => {
    const [open, setOpen] = useState(false)

    const handleSave = model => {
      onSave(model.description)
      setOpen(false)
    }

    return <>
      <DefaultPopover
        trigger={<Button variant='outline' color='accent'>{children}</Button>}
        wrapperProps={{ open, onOpenChange: setOpen }}
      >
        <div className='flex justify-between items-center font-semibold'>
          Save Current Search
          <XIcon size='16' className='cursor-pointer' onClick={() => setOpen(false)} />
        </div>
        <Separator className='m-0 my-2' />
        <NestedForm onValidSubmit={handleSave}>
          <Row>
            <Col size='12'>
              <FormGroup>
                <Label>New Search Name</Label>
                <Input name='description' required />
              </FormGroup>
            </Col>
            <Col size='12'>
              <FormGroup>
                <Button type="submit" block size='sm' color="accent" className="mr-2">Save</Button>
              </FormGroup>
            </Col>
          </Row>
        </NestedForm>
      </DefaultPopover>
    </>
  }

  Form = ({ children }) => {
    const { customFields: { getFields } } = useGlobalStore()
    const { fields, values } = this.state

    const loadFields = useCallback(async () => {
      const data = await getFields({ parse: true })
      const customFields = data.map(({ key: name, name: label, type, options }) => {
        options = type === 'boolean' ? booleanOptions : options
        return { name, label, type, size: 3, options }
      })
      const allFields = {}
      Object.keys({ ...profileFields, customFields }).map(group => {
        allFields[group] = { ...profileFields, customFields }[group].map(field => ({ ...field, group: group }))
      })
      this.setState({ fields: allFields, groups: Object.keys(allFields) })
    }, [getFields])

    useEffect(() => {
      loadFields()
    }, [loadFields])

    if (!values || !fields) {
      return null
    }

    return <Form onSubmit={this.handleRunSearch} fields={fields} data={values} onChange={this.hangleChangeForm}>
      {children}
    </Form>
  }

  render() {
    const { open, savedSearches } = this.state

    return <>
      <DefaultSheet
        title='User Profile Tool'
        trigger={<DefaultTooltip content='User profilling tool' triggerProps={{ asChild: true }}>
          <User size='28' className='twy-text-accent cursor-pointer' />
        </DefaultTooltip>}
        wrapperProps={{ open, onOpenChange: () => this.toggleModal() }}
        contentProps={{ className: 'w-[110em]' }}
      >
        <Row>
          <Col size='12'>
            <this.Form>
              <this.SaveSearchPopOver onSave={this.handleSaveSearch} target='btnSaveSearch' >
                Save
              </this.SaveSearchPopOver>
              <this.LoadSearchPopOver data={savedSearches} onLoadSearch={this.handleLoad} onDelete={this.handleDelete} target='btnLoadSearch' >
                Load
              </this.LoadSearchPopOver>
            </this.Form>
          </Col>
          <Col size='12'>
            <this.ResultTable />
          </Col>
        </Row>
      </DefaultSheet>
    </>
  }
}

class NestedForm extends Formsy {
  constructor(props) {
    super(props)
    const { submit } = this
    this.submit = event => {
      event.stopPropagation()
      submit(event)
    }
  }
}

ProfileTool.propTypes = propTypes
ProfileTool.defaultProps = {}
